/**
 * Menu option identifiers for the ThreeDotsWithClickableOptions component.
 */
export const MENU_OPTIONS = {
  VIEW_GUIDELINES: "view_guidelines",
  VIEW_TX_PLAN: "view_tx_plan",
  VIEW_IN_ONCO_EMR: "view_in_onco_emr",
  VIEW_DX_CODES: "view_dx_codes",
  VIEW_NAR_GRID: "view_nar_grid",
  INGEST_IN_PATIENT_GRAPH: "ingest_in_patient_graph",
  /** Opens the document merger modal from the three-dots menu. */
  MERGE_DOCUMENTS: "merge_documents",
} as const;

export type MenuOptionId = (typeof MENU_OPTIONS)[keyof typeof MENU_OPTIONS];

/** Idle label for the patient-graph ingest option. */
export const INGEST_IN_PATIENT_GRAPH_LABEL = "Ingest in Patient Graph";

/** Label shown while an ingest request is in flight. */
export const INGESTING_IN_PATIENT_GRAPH_LABEL = "Ingesting...";

/**
 * Menu option configuration with text and id.
 */
export interface MenuOption {
  text: string;
  id: MenuOptionId;
}

/**
 * All available menu options in display order.
 */
const ALL_MENU_OPTIONS: MenuOption[] = [
  { text: "View Guidelines", id: MENU_OPTIONS.VIEW_GUIDELINES },
  { text: "View Tx Plan", id: MENU_OPTIONS.VIEW_TX_PLAN },
  { text: "View in Onco EMR", id: MENU_OPTIONS.VIEW_IN_ONCO_EMR },
  { text: "View DX Codes", id: MENU_OPTIONS.VIEW_DX_CODES },
  { text: "View NAR Grid", id: MENU_OPTIONS.VIEW_NAR_GRID },
  {
    text: INGEST_IN_PATIENT_GRAPH_LABEL,
    id: MENU_OPTIONS.INGEST_IN_PATIENT_GRAPH,
  },
  { text: "Document Studio", id: MENU_OPTIONS.MERGE_DOCUMENTS },
];

/**
 * Generates the menu options list based on available order data.
 *
 * @param showGuidelines - Whether to include the "View Guidelines" option
 * @param showIngestInPatientGraph - Whether to include "Ingest in Patient Graph"
 * @returns Array of menu options
 */
export const getMenuOptionsList = (
  showGuidelines: boolean,
  showIngestInPatientGraph: boolean = true,
): MenuOption[] =>
  ALL_MENU_OPTIONS.filter((option) => {
    if (!showGuidelines && option.id === MENU_OPTIONS.VIEW_GUIDELINES) {
      return false;
    }
    if (
      !showIngestInPatientGraph &&
      option.id === MENU_OPTIONS.INGEST_IN_PATIENT_GRAPH
    ) {
      return false;
    }
    return true;
  });
